import { createContext, useContext } from 'react';
import type { WalletClient, Address } from 'viem';
import type { Chain } from 'viem/chains';

export interface WalletInterface {
  chain: Chain;
  ready: boolean;
  authSettled: boolean;
  isConnected: boolean;
  isConnecting: boolean;
  address?: Address;
  walletClient?: WalletClient;
  disconnect: () => void;
}

export const WalletContext = createContext<WalletInterface>({
  ready: false,
  authSettled: false,
  isConnected: false,
} as WalletInterface);

export const useWallet = () => {
  return useContext(WalletContext);
};
